import { sendDelete, sendGet, sendPost, sendPostFile, sendPut } from "./axios";

// eslint-disable-next-line import/prefer-default-export

export const createTableSession = (payload: any) =>
  sendPost("/api-client/table-session/create", payload);

export const getListTableSession = (payload: any) =>
  sendGet("/api-client/table-session/list", payload);

export const getDetailTableSession = (id: any) =>
  sendGet(`/api-client/table-session/detail/${id}`);

export const updateTableSession = (payload: any) =>
  sendPut(`/api-client/table-session/update/${payload?.id}`, payload?.data);

export const getListStaffDuplicate = (params: any) =>
  sendGet(`/api-client/table-session/list-duplicate`, params);

export const getListTableHistory = (params: any) =>
  sendGet(`/api-client/table-session/history`, params);

export const nextStepTableSession = (payload: any) =>
  sendPut(`/api-client/table-session/next-step/${payload?.id}`, payload?.data);

export const deleteTableSession = (tableId: any) =>
  sendDelete(`/api-client/table-session/delete/${tableId}`);

export const checkHaveTableSessionNotDone = (params: any) =>
  sendGet(`/api-client/table-session/check-session-done`, params);

export const getListTimeWorkStaff = (params: any) =>
  sendGet(`/api-client/table-session/list-time-working-staff`, params);

export const updateTableStep = (payload: any) =>
  sendPut(
    `/api-client/table-session/update-step/${payload?.id}`,
    payload?.data
  );

export const updateTableTime = (payload: any) =>
  sendPut(
    `/api-client/table-session/update-time/${payload?.id}`,
    payload?.data
  );

export const exportCsv = (payload: any) =>
  sendPostFile(`/api-client/table-session/export-csv`, payload);

export const syncDataTableSession = (payload: any) =>
  sendPost("/api-client/table-session/sync-data", payload);
export const updateTableSessionRealtime = (payload?: any) =>
  sendPost("/api-client/table-session/update-table-session-realtime", payload);
